import React from "react";
import AddAgentForm from '../containers/AddAgentForm';
import Header from '../containers/Header';

function AddAgent() {

  return (
    <div>
      <Header />
      <AddAgentForm />
    </div>

  );
}

export default AddAgent;